<!--
  创建时间：2024/8/23 14:20
  创建人：toyehuang
  PorpertyTransaction 首页 项目信息模块
-->

<template>
  <div class="porperty-block f-column-b" :style="computedHeightStyle">
    <block-head
      :title="title"
      :subtitle="subtitle"
      :icon="icon"
      :more-btn-url="moreBtnUrl"
    />
    <div class="block-head">
      <ul class="f-start-c flex-1">
        <li
          v-for="nt in businessTypeList"
          :key="nt.code"
          class="fc99 mr-17"
          :class="{ active: nt.code === activeType }"
          @click="changeBusinessType(nt.code)"
        >
          {{ nt.name }}
        </li>
        <li
          v-for="nt in systemTypeList"
          :key="nt.code"
          class="fc99 mr-17"
          :class="{ active: nt.code === activeType }"
          @click="changeSystemType(nt.code)"
        >
          {{ nt.label }}
        </li>
      </ul>
    </div>
    <div class="list">
      <el-table
        v-if="list.length"
        class="project-table"
        :data="list"
        fit
        :default-sort="{ prop: 'endTime', order: null }"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @row-click="rowClick"
      >
        <template v-if="tableType == 1">
          <el-table-column
            label="项目名称"
            min-width="380"
            header-align="center"
          >
            <template #default="{ row }">
              <div class="text-cut" :title="row.title">
                <!-- <span v-if="row.areaName" class="color-theme-red">[{{ row.areaName }}]</span> -->
                {{ row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="categoryname"
            label="类别"
            width="120"
            align="center"
          />
          <el-table-column
            prop="priceFormat"
            label="挂牌价"
            width="220"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="!hidColumns.includes('endDateFormat')"
            prop="endDateFormat"
            label="挂牌截止时间"
            width="180"
            align="center"
          />
          <el-table-column
            v-if="!hidColumns.includes('status')"
            label="项目状态"
            width="170"
            align="center"
          >
            <template #default="scope">
              <span v-if="scope.row.ispllr == '1'" class="table-btn btn-bidding"
                >详见公告</span
              >
              <span v-if="scope.row.ispllr == '0'">
                <span
                  v-if="scope.row.statusName == '已重新挂牌'"
                  class="table-btn btn-default"
                  >已重新挂牌</span
                >
                <span
                  v-if="scope.row.statusName == '正在报名'"
                  class="table-btn btn-enroll"
                  >报名中</span
                >
                <span
                  v-if="scope.row.statusName == '正在报名|竞价中'"
                  class="table-btn btn-enroll"
                >
                  <!--                <span class="table-btn  btn-bidding">竞价中</span>-->
                  报名中
                </span>
                <span
                  v-if="scope.row.statusName == '项目终结'"
                  class="table-btn btn-default"
                  >项目终结</span
                >
                <span
                  v-if="scope.row.statusName == '项目中止'"
                  class="table-btn btn-default"
                  >项目中止</span
                >
                <span
                  v-if="scope.row.statusName == '竞价暂停'"
                  class="table-btn btn-default"
                  >竞价暂停</span
                >
                <span
                  v-if="scope.row.statusName == '竞价截止'"
                  class="table-btn btn-default"
                  >竞价截止</span
                >
                <span
                  v-if="scope.row.statusName == '未开始'"
                  class="table-btn btn-default"
                  >未开始</span
                >
                <span
                  v-if="scope.row.statusName == '报名截止'"
                  class="table-btn btn-default"
                  >报名截止</span
                >
                <span
                  v-if="scope.row.statusName == '竞价中'"
                  class="table-btn btn-bidding"
                  >竞价中</span
                >
                <span
                  v-if="scope.row.statusName == '已成交'"
                  class="table-btn none btn-default"
                  >已成交</span
                >
              </span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            label="项目名称"
            min-width="180"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <div class="text-cut" :title="row.title">
                {{ row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="fbstartDate"
            label="发布时间"
            width="350"
            align="center"
          />
        </template>
      </el-table>
      <no-data v-else :no-txt="noTxt" :no-img="noImg" :text="$attrs.text" />
    </div>
  </div>
</template>

<script>
import {
  getConstantDic,
  INFO_TYPE_OPTIONS3,
  PROJECT_STATUS_OPTIONS,
  SELECT_OPTION_CONFIG,
} from "@/utils/constant";
import porpertyApi from "@/api/porperty";
import noticeApi from "@/api/newnotice";
import NoData from "@/components/NoData.vue";
import { parseTime } from "@/filters";
import BlockHead from "@/views/home/components/BlockHead.vue";

export default {
  name: "AssetTransaction",
  components: { BlockHead, NoData },
  props: {
    defaultParams: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: "asset",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "1",
    },
    hidTab: {
      type: Boolean,
      default: false,
    },
    // 需要隐藏的 column
    hidColumns: {
      type: Array,
      default: () => [],
    },
    // 模块高度
    blockHeight: {
      type: [Number, String],
      default: "511px",
    },
    // 最多显示多少行
    rows: {
      type: [Number, String],
      default: 8,
    },
    noTxt: {
      type: Boolean,
      default: true,
    },
    noImg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      businessTypeList: "",
      systemTypeList: getConstantDic(INFO_TYPE_OPTIONS3),
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: Object.values(PROJECT_STATUS_OPTIONS),
      code: SELECT_OPTION_CONFIG.CODE,
      systemType: "",
      list: [],
      orderType: "orderType3_down",
      businessType: "",
      projectType: "",
      tableType: 1,
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      if (this.type == 1) {
        return this.$router.resolve({
          path: "/porperty/list/xmgg_gyzcjy",
          query: {
            businessType: this.businessType,
            systemType: this.systemType,
            ...this.defaultParams,
          },
        })?.href;
      }
      if (this.type == 2) {
        return this.$router.resolve({
          path: "/porperty/list/xmgg_zrzyjy",
          query: {
            businessType: this.businessType,
            systemType: this.systemType,
            ...this.defaultParams,
          },
        })?.href;
      }
    },
    activeType() {
      return this.businessType || this.systemType || "";
    },
    computedHeightStyle() {
      let height = this.blockHeight;
      if (typeof this.blockHeight === "string") {
        height = height.replace("px", "");
      }
      return { height: height + "px" };
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    await this.getBusinessTypeListByType();
    await this.getList();
  },
  // 方法集合
  methods: {
    getBusinessTypeListByType() {
      const params = {
        type: this.type,
      };
      porpertyApi.getBusiness(params).then((res) => {
        if (res.code === 0) {
          const allOption = { code: "", name: "全部" };
          this.businessTypeList = [allOption, ...(res.data || [])];
        }
      });
    },
    changeBusinessType(code) {
      this.businessType = code;
      this.systemType = "";
      this.tableType = 1;
      this.getList();
      this.blockHeight = "511px";
    },
    changeSystemType(code) {
      this.businessType = "";
      this.systemType = code;
      this.tableType = 2;
      this.getNoticeList();
      this.blockHeight = "511px";
    },
    // 获取列表
    getList() {
      const params = {
        pageNo: 1,
        pageSize: 8,
        xmType: this.type,
        businessType: this.businessType,
        projectType: this.projectType,
        orderType: this.orderType || "default", // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
        ...this.defaultParams,
      };
      porpertyApi.page(params).then((res) => {
        if (res.code === 0) {
          const data = res.data || {};
          this.total = data.total || 0;
          this.list = data.list ?? [];
        }
      });
    },
    // 获取公告列表数据
    getNoticeList() {
      const params = {
        pageNo: 1,
        pageSize: 8,
        systemType: "CQJY",
        xmType: this.type,
        noticeType: this.systemType === "BGGG" ? "BGGG" : "CJGG",
      };
      noticeApi.page(params).then((res) => {
        if (res.code === 0) {
          const data = res.data || {};
          const list = data.list || [];
          this.total = data.total || 0;
          list.forEach((e) => {
            e.fbstartDate = parseTime(e.fbstartDate, "{y}-{m}-{d}");
          });
          this.list = data.list;
        }
      });
    },
    headerCellStyle({ columnIndex }) {
      return "background-color: #f9f9f9;padding: 4px 0;";
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;";
      // if (columnIndex === 4) {
      //   str += "display: flex;justify-content: center;"
      // }
      if (rowIndex === 7) {
        str += "border: none;";
      }
      return str;
    },
    // 行点击
    rowClick(row) {
      if (row.noticeUrl) {
        window.open(row.noticeUrl, "_blank");
      } else {
        const route = this.$router.resolve({
          path:
            this.type == 1
              ? "/porperty/detail/xmgg_gyzcjy"
              : "/porperty/detail/xmgg_zrzyjy",
          query: {
            id: this.tableType == 1 ? row.infoId : row.id,
            tableType: this.tableType,
          },
        });
        window.open(route.href, "_blank");
      }
    },
    // 排序
    handleSortChange({ order }) {
      this.orderType =
        order === "descending"
          ? "endTime_down"
          : order === "ascending"
          ? "endTime_up"
          : "";
      this.getList("0");
    },
  },
};
</script>

<style scoped lang="scss">
.block-head {
  margin: 16px 0 0 0;
  ul > li {
    cursor: pointer;
    &.active {
      color: $--color-primary;
      font-weight: bold;
    }
    &:hover {
      color: $--color-primary;
    }
  }
}
.porperty-block {
  width: 100%;

  .list {
    flex: 1;
    min-height: 0;
    border: 1px solid #ddd;
    margin-top: 18px;
    .project-table {
      &::before {
        height: 0;
      }
      .table-btn {
        display: inline-block;
        width: 70px;
        height: 23px;
        line-height: 23px;
        color: #fff;
        text-align: center;
      }
    }
  }
}
</style>
